import { ROOT_FOLDER_NAME } from "../../../consts";
import type { LetterFileDocumentDto } from "../../../dto/letter-file-document.dto";
import type { LetterFileFolderDto } from "../../../dto/letter-file-folder.dto";

export function findDocumentsByIds(documents: LetterFileDocumentDto[], ids: number[]): LetterFileDocumentDto[] {
  return ids.flatMap(id => documents.find(document => document.id === id) ?? []);
}

export function getFolderName(folder: LetterFileFolderDto) {
  if (folder.name === ROOT_FOLDER_NAME) return "Dossier racine";
  return folder.name;
}
